<template>
  <div>
    <!-- Show SignPdf component initially -->
    <div v-if="currentView === 'sign'">
      <sign-pdf 
        :isEmbedded="false" 
        @navigate-to-editor="handleNavigateToEditor"
      />
    </div>

    <!-- Show PdfEditor component after navigation -->
    <div v-else-if="currentView === 'editor'">
      <pdf-editor 
        :initialSignature="signatureData"
        @back-to-sign="handleBackToSign"
        @pdf-uploaded="handlePdfUploaded"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import SignPdf from './SignPdf.vue'
import PdfEditor from './PdfEditor.vue'

const currentView = ref('sign') // 'sign' or 'editor'
const signatureData = ref(null)
const hasPdfUploaded = ref(false)

// Watch for changes and hide/show hero text and other sections in DOM
watch([currentView, hasPdfUploaded], ([view, uploaded]) => {
  const elementsToToggle = [
    'hero-text',
    'what-is-section', 
    'how-to-section', 
    'faq-section',
    'footer-section'
  ]

  elementsToToggle.forEach(id => {
    const el = document.getElementById(id)
    if (el) {
      if (view === 'editor' && uploaded) {
        el.style.display = 'none'
      } else {
        el.style.display = 'block'
      }
    }
  })
})

function handleNavigateToEditor(signature) {
  // Save signature data
  signatureData.value = signature
  // Switch to editor view
  currentView.value = 'editor'
}

function handleBackToSign() {
  // Go back to sign view
  currentView.value = 'sign'
  hasPdfUploaded.value = false
}

function handlePdfUploaded() {
  // PDF has been uploaded
  hasPdfUploaded.value = true
}
</script>
